import React, { useEffect } from "react";
import "./index.m.css";
import { SUBSCRIBE_PAGE_TEXT } from "../../../../constants";
import Whatsapp from "../../../atoms/social-media-icons/Whatsapp";
import Mail from "../../../atoms/social-media-icons/Mail";
import { SpinnerIcon } from "../onboard-modal/icons";

export const UpgradeModal = ({ onClose, onConfirm, isLoading }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div styleName="overlay" onClick={onClose}>
      <div styleName="popupContainer" onClick={(e) => e.stopPropagation()}>
        <h2 styleName="title">ಯೋಜನೆ ಬದಲಾವಣೆ ಕೋರಿಕೆ ಸಲ್ಲಿಕೆಯಾಗಿದೆ</h2>

        <p styleName="message">ಯೋಜನೆ ಬದಲಾವಣೆೆಯ ನಿಮ್ಮ ಕೋರಿಕೆ ದಾಖಲಾಗಿದೆ. ನಿಮ್ಮ ನೋಂದಾಯಿತ ಇಮೇಲ್ ವಿಳಾಸ ಅಥವಾ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮ್ಮ ಗ್ರಾಹಕ ನೆರವಿನ ವಿಭಾಗವು 2 ರಿಂದ 3 ಕಾರ್ಯನಿರ್ವಹಿಸುವ ದಿನಗಳಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ ಯೋಜನೆ ಬದಲಾವಣೆಗೆ ನಿಮಗೆ ನೆರವಾಗಲಿದ್ದಾರೆ.</p>

        <p styleName="message">ನಿಮ್ಮ ಹಾಲಿ ಯೋಜನೆಯು ಯಾವುದೇ ಅಡಚಣೆ ಇಲ್ಲದೆ ಮುಂದುವರಿಯಲಿದೆ ಯಾವುದೇ ಹೆಚ್ಚಿನ ಮಾಹಿತಿ ಬೇಕಿದ್ದಲ್ಲಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಬಹುದು.</p>

        <div styleName="contactsWrapper">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://api.whatsapp.com/send/?phone=919035267304&text=Hi%2C%20I%20need%20assistance%20with%20my%20Prajavani%20Premium%20Subscription.%20Could%20you%20please%20help%20me%3F&type=phone_number&app_absent=0", "_blank", "noopener,noreferrer");
            }}
            styleName="whatsappButton"
          >
            <Whatsapp width={18} height={18} color="#25D366" />
            <span styleName="whatsappText">+91 9035267304</span>
          </a>

          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://mail.google.com/mail/u/0/?fs=1&to=support@prajavani.net&su=Support+Required+for+PV+subscription&body=Hi%2C+I+need+assistance+with+my+Prajavani+Premium+Subscription.+Could+you+please+help+me%3F&tf=cm", "_blank", "noopener,noreferrer");
            }}
            styleName="mailButton"
          >
            <Mail width={16} height={12} color="#000" />
            <span styleName="mailText">support@prajavani.net</span>
          </a>

          <div>
            <p styleName="workingHoursLabel">ಕೆಲಸದ ಸಮಯ</p>
            <p styleName="workingHoursTime">ಸೋಮವಾರದಿಂದ ಶುಕ್ರವಾರ: ಬೆಳಿಗ್ಗೆ 10 ರಿಂದ ಸಂಜೆ 6</p>
          </div>
        </div>

        <button styleName="actionButton" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? <SpinnerIcon styleName="spinner" /> : SUBSCRIBE_PAGE_TEXT.UPGRADE_POPUP_BTN}
        </button>
      </div>
    </div>
  );
};
